import { defaultHoverTransition } from '@shared/utils';
import cx from 'classnames';

import useCreateNewRoomDataContext from 'modules/CreateNewRoomModal/CreateNewRoomDataProvider/useCreateNewRoomDataContext';

interface SuggestionDropdownProps {
  onClick: () => void;
}

const SuggestionDropdown = ({ onClick }: SuggestionDropdownProps) => {
  const {
    roomForm: { watch },
  } = useCreateNewRoomDataContext();

  const inputWatch = watch('participantInput');

  return (
    <div className="absolute border w-full bg-white top-13 rounded-xl p-2 shadow-dropdown">
      <div
        className={cx(
          'w-full cursor-pointer hover:bg-primary-10 rounded-lg p-2 text-black text-size-sm truncate',
          defaultHoverTransition
        )}
        onClick={onClick}
      >
        <span>{inputWatch}</span>
      </div>
    </div>
  );
};

export default SuggestionDropdown;
